import { CanDeactivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { CanComponentDeactivate } from '@pkp-g/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
  canDeactivate(component: CanComponentDeactivate): boolean | Observable<boolean> {
    return component.canDeactivate();
  }
}
